import { REDUCE_POLICY_TERMS } from '../../constants/actions/policy';

export function reducePolicyTerms(payload) {
    return {
        type: REDUCE_POLICY_TERMS,
        payload,
    };
}
